<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import {mapGetters} from "vuex";

export default {
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch','isEdit','placeholderTxt','disabled', 'roleSubmit', 'submitter'],
  data() {
    return {
      currentInputSelectData: "",
      header: this.$constant.tableHeaders.common.searchs.user,
      busyGetData: false,
      data: [],
      visible: false,
      filters: {
        searchValue: "",
        column: "users.user_cd",
        dir: "ASC",
        page: 1
      }
    };
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_users, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
      }
    },
    updateValue: function(value, item) {
      this.dataSearch.user = value;
      this.$emit('dataSelected', this.dataSearch.user, item)
      this.closeModal();
    },
    openModal() {
      this.$bvModal.show("modal-select-data-user");
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-user");
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    headers() {
      return this.header;
    },
    inputSearch: {
      get() {
        return this.dataSearch.user;
      },
      set(newValue) {
        this.dataSearch.user = newValue;
      }
    },
    showUser: function () {
      let vm = this
      return function (item) {
        let isNewSubmit = !this.submitter && item.id == this.user.id
        let hasSumitter = this.submitter && this.submitter.user_id_created_by == item.id
        return !(hasSumitter || isNewSubmit)
      }
    }
  },
};
</script>
<template>
  <div class="d-flex gap-2">
    <input
      type="text"
      :disabled ="!isEdit"
      :placeholder="placeholderTxt"
      class="form-control"
      v-model="inputSearch"
    />
    <b-button
      :disabled="disabled"
      v-b-modal.modal-select-data-user
      variant="outline-info"
    ><i class="bx bx-file-find"></i></b-button>
    <!-- modal area -->
    <b-modal
      size="xl"
      title="社員一覧"
      id="modal-select-data-user"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row>
        <div>
          <b-form-input
            placeholder="フィルター..."
            v-model="filters.searchValue"
            v-on:keyup.enter="performDebounceSearch"
            type="text"
            id="name"
          ></b-form-input>
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data"
                :key="index"
                class="cursor-pointer"
                @click="updateValue(item.user_name, item)"
                
              >
                <td>
                  {{ item.user_cd}}
                </td>
                <td>
                  {{ item.department_name }}
                </td>
                <td>
                  {{ item.user_name }}
                </td>
                <td>
                  {{ item.tel }}
                </td>
                <td>
                  {{ item.email }}
                </td>
              </tr>
              <tr v-if="!data.length && !busyGetData">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
